<template>
  <div>
    <vs-popup title="Inserir vídeo" :active.sync="videoPopup">
      <div>
        <vs-button
          size="small"
          icon="publish"
          style="font-size: .9em; margin: 0 auto;"
          @click="handleSubUploadButton"
        >
          Escolher Arquivo de Vídeo
        </vs-button>
      </div>

      <vs-input
        type="file"
        @change="handleVideoUpload($event, `quillEdit${currentRef}`)"
        accept=".mp4,.mov"
        hidden
        id="uploadVideo"
      />

      <vs-divider>OU</vs-divider>

      <vs-input
        label="URL do Vídeo"
        v-model="videoUrl"
        class="w-full mt-5"
        name="videoUrl"
      />

      <vs-button
        class="mt-5 float-right"
        :disabled="videoUrl === ''"
        @click="handleVideoUrl(`quillEdit${currentRef}`)"
      >
        Confirmar
      </vs-button>
    </vs-popup>

    <NewsPreviewPopup
      :isPreviewPopupActive="isPreviewPopupActive"
      :newsData="newsData"
      @closePreviewPopup="isPreviewPopupActive = false"
    />

    <form class="form form-vertical">
      <div class="form-body">
        <div class="row">
          <!-- Headline -->
          <vx-input-group class="mb-base">
            <vs-input
              label="Título"
              v-model="newsData.headline"
              class="w-full"
              name="Título"
              v-validate="'required'"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('Título')"
            >{{ errors.first('Título') }}</span>
          </vx-input-group>
          <!-- Subtitle -->
          <vx-input-group class="mb-base">
            <vs-input
              label="Linha Fina"
              v-model="newsData.subtitle"
              class="w-full"
              name="Linha Fina"
              v-validate="'required'"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('Linha Fina')"
            >{{ errors.first('Linha Fina') }}</span>
          </vx-input-group>

          <!-- Call -->
          <vx-input-group class="mb-base">
            <vs-input
              label="Chapéu"
              v-model="newsData.call"
              class="w-full"
              name="Chapéu"
              v-validate="'required'"
              description-text="Essa informação aparecerá acima da miniatura da notícia"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('Chapéu')"
            >{{ errors.first('Chapéu') }}</span>
          </vx-input-group>

          <!-- Image -->
          <vx-input-group class="mb-base">
            <!-- <label for="" class="vs-input--label">Faça o Upload da Miniatura</label>

            <upload
              :action="uploadApiUrl"
              fileName="file"
              :headers="{
                Authorization: 'Bearer ' + bearer,
              }"
              text="Escolher Anexo"
              automatic
              :limit="1"
              accept="image/jpeg, image/png"
              :single-upload="true"
              @on-success="successUploadImage"
              @on-error="errorUploadImage"
              ref="uploadComponent"
              @on-upload-start="deleteUploadImage"
            /> -->
            <vs-input
              type="file"
              label="Faça o Upload da Miniatura"
              @change="uploadThumbnail"
              class="w-full"
              accept="image/jpeg, image/png"
            />

            <vs-input
              v-model="newsData.thumbnail"
              class="mt-1 w-full"
              name="Miniatura"
              readonly
              style="display: none;"
              v-validate="'required'"
            />

            <span
              class="text-danger text-sm"
              v-show="errors.has('Miniatura')"
            >{{ errors.first('Miniatura') }}</span>

            <div v-if="!!newsData.thumbnail">
              <div style="max-width: 200px; margin-top: 10px;">
                <img :src="newsData.thumbnail" width="100%" height="100%" />
              </div>
              <a :href="newsData.thumbnail" target="_blank">Visualizar Miniatura da Notícia</a>
            </div>

            <div style="clear: both;"></div>
          </vx-input-group>

          <!-- Content -->
          <vx-input-group class="mb-base">
            <button
              type="button"
              id="selectVideo"
              @click="handleVideoClick()"
              style="display: none;"
            ></button>

            <vs-input
              type="file"
              @change="handleAudios($event, 'quillEdit')"
              id="selectAudio"
              hidden
              accept=".mp3,.ogg"
            />

            <vs-input
              type="file"
              @change="handleImages($event, 'quillEdit')"
              id="selectFile"
              hidden
              accept="image/jpeg, image/png"
            />
            <label class="vs-input--label">Conteúdo da Notícia</label>

            <quill-editor
              v-model="newsData.content"
              :options="editorOptions()"
              class="w-full"
              rows="10"
              name="Conteúdo"
              id="content"
              v-validate="'required'"
              ref="quillEdit"
            />

            <span
              class="text-danger text-sm"
              v-show="errors.has('Conteúdo')"
            >{{ errors.first('Conteúdo') }}</span>
          </vx-input-group>

          <!-- Hidden Content -->
          <vx-input-group class="mb-base">
            <button
              type="button"
              id="selectVideo2"
              @click="handleVideoClick(2)"
              style="display: none;"
            ></button>

            <vs-input
              type="file"
              @change="handleAudios($event, 'quillEdit2')"
              id="selectAudio2"
              hidden
              accept=".mp3,.ogg"
            />

            <vs-input
              type="file"
              @change="handleImages($event, 'quillEdit2')"
              id="selectFile2"
              hidden
              accept="image/jpeg, image/png"
            />
            <label class="vs-input--label">Conteúdo Ofuscado da Notícia</label>
            <br />
            <label class="vs-input--label">Aparecerá quando o usuário clicar no botão "Ler Mais"</label>

            <div style="clear: both"></div>

            <quill-editor
              v-model="newsData.hidden_content"
              :options="editorOptions(2)"
              class="w-full"
              rows="10"
              name="Conteúdo Ofuscado"
              id="hidden_content"
              v-validate="'required'"
              ref="quillEdit2"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('Conteúdo Ofuscado')"
            >{{ errors.first('Conteúdo Ofuscado') }}</span>
            <span
              v-if="newsData.id"
              class="mt-3 text-sm"
            >Essa notícia já foi expandida {{ newsData.expanded_qty }} vezes!</span>
          </vx-input-group>

          <!-- <vx-input-group class="mb-base">
            {{ newsData.content }}
          </vx-input-group>-->

          <!-- Category -->
          <vx-input-group class="mb-base">
            <vs-select
              label="Caderno"
              placeholder="Buscar caderno..."
              v-model="newsData.category.id"
              class="w-full"
              autocomplete
              name="Caderno"
              v-validate="'required'"
              ref="selectCategory"
            >
              <vs-select-item
                :key="index"
                :value="item.id"
                :text="item.name"
                v-for="(item,index) in categories"
              />
            </vs-select>
            <span
              class="text-danger text-sm"
              v-show="errors.has('Caderno')"
            >{{ errors.first('Caderno') }}</span>
          </vx-input-group>

          <div class="mb-10 w-full flex flex-row">
            <div class="w-3/12 flex justify-start items-center">
              <div class="w-full flex justify-start items-center">
                <span class="phone-number-span mr-8 flex justify-center items-center flex-direction-row" style="font-size: .8rem !important;">
                  <vs-radio v-model="sendingType" vs-name="sendingType" vs-value="now">
                    Publicação Imediata
                  </vs-radio>

                  <vx-tooltip text="A notícia será publicada logo após a criação">
                    <feather-icon icon="HelpCircleIcon" class="ml-2"></feather-icon>
                  </vx-tooltip>
                </span>
              </div>
            </div>

            <div class="w-3/12 flex justify-start items-center">
              <div class="w-full flex justify-start items-center">
                <span class="phone-number-span ml-8 flex justify-center items-center flex-direction-row" style="font-size: .8rem !important;">
                  <vs-radio v-model="sendingType" vs-name="sendingType" vs-value="schedule">
                    Selecionar Horário
                  </vs-radio>

                  <vx-tooltip text="A notícia será publicada automaticamente na data e hora definida">
                    <feather-icon icon="HelpCircleIcon" class="ml-2"></feather-icon>
                  </vx-tooltip>
                </span>
              </div>
            </div>
          </div>

          <div v-if="sendingType === 'schedule'" class="mb-10 w-full">
            <div class="w-full">
              <span class="phone-number-span mr-12">
                Data e Hora da Publicação Automática
              </span>
            </div>

            <flat-pickr 
              :config="configdateTimePicker"
              v-model="schedulePublishAtPtBr"
              name="schedule_publish_at"
              class="w-full"
            />
          </div>

          <!-- Activated -->
          <div class="mb-10">
            <vx-input-group class="mb-2" v-if="newsData.id">
              <vs-checkbox
                v-model="newsData.activated"
                class="custom-control-label"
                name="activated"
                :disabled="disableActivated"
              >
                Ativo
              </vs-checkbox>
            </vx-input-group>

            <vs-alert
              v-if="disableActivated && newsData.id !== null"
              active="true" 
              color="warning" 
              icon="error"
            >
              Essa notícia está agendada para ser publicada em {{ schedulePublishAtPtBr }}, portanto
              não é possível alterar o status dela. A notícia entrará como <strong>Ativa</strong> no momento
              em que for publicada automaticamente.
            </vs-alert>

            <vs-alert
              v-if="!newsData.activated && newsData.is_highlighted"
              active="true" 
              color="warning" 
              icon="error"
            >
              Essa notícia está marcada como destaque! Desativá-la fará com que ela seja
              removida dos destaques automaticamente.
            </vs-alert>
          </div>

          <!-- Submit -->
          <div>
            <vs-alert active="true" class="mb-5" color="rgb(111, 38, 224)" icon="warning">
              Não se esqueça de colocar, pelo menos, uma foto e o áudio (Soar) antes da parte 1 do texto!
            </vs-alert>

            <div style="float: left;">
              <vx-input-group>
                <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Salvar</vs-button>
              </vx-input-group>
            </div>

            <vs-button
              color="primary"
              @click="isPreviewPopupActive = true"
              type="flat"
              icon="view_quilt"
              size="small"
              style="float: left; font-size: 1em;"
              class="mb-2"
            >Pré-visualizar Notícia</vs-button>

            <div style="clear: both"></div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import Upload from '@/components/upload/Upload'
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import NewsPreviewPopup from "./NewsPreviewPopup";

import flatPickr from 'vue-flatpickr-component'
import { Portuguese } from 'flatpickr/dist/l10n/pt.js'
import 'flatpickr/dist/flatpickr.css'

import { quillEditor } from "vue-quill-editor";
import toolbarOptions from "@/utils/defaultToolbarOptions";

import moduleCategory from "@/store/category/moduleCategory";
import moduleNews from "@/store/news/moduleNews";
import {
  encodeToBase64,
  decodeFromBase64,
  detectAndRemoveFileFromBucket,
  uploadFile,
  formatDate
} from "@/utils";

import fileHttp from "@/http/requests/file";

export default {
  name: "news-form",
  props: {
    news: {
      type: Object,
      required: false,
      default: () => {
        return {
          id: null,
          headline: "",
          slug: "",
          subtitle: null,
          content: "",
          hidden_content: "",
          thumbnail: null,
          call: null,
          activated: true,
          category: {
            id: null,
            name: null
          },
          author: {
            id: null,
            username: null,
            name: null,
            email: null,
            role: {
              id: null,
              name: null
            }
          },
          expanded_qty: 0,
          schedule_publish_at: null
        };
      }
    }
  },
  data() {
    return {
      newsData: {},
      isPreviewPopupActive: false,
      videoPopup: false,
      videoUrl: '',
      currentRef: '',
      quillEditorRange: 0,
      pickrConfig: {
        enableTime: true,
        noCalendar: false,
        dateFormat: "d/m/Y H:i",
        locale: Portuguese
      },
      schedulePublishAtPtBr: '',
      sendingType: ''
    }
  },
  watch: {
    videoPopup(videoPopup) {
      if (!videoPopup) {
        this.videoUrl = ''
        this.currentRef = ''
        this.quillEditorRange = 0
      }
    }
  },
  computed: {
    configdateTimePicker() {
      let minDate = new Date
      
      console.log(this.newsData.schedule_publish_at)
      if(this.newsData.schedule_publish_at) {
        minDate = new Date(this.newsData.schedule_publish_at)
      }

      return {
        ...this.pickrConfig,
        minDate
      }
    },
    categories() {
      return this.$store.state.category.categories;
    },
    isFormValid() {
      return !this.errors.any();
    },
    disableActivated() {
      return this.newsData.schedule_publish_at !== null && 
              this.formattedSchedulePublishAt !== '' &&
              new Date() < new Date(this.newsData.schedule_publish_at)
    },
    schedulePublishAtDate() {
      return this.newsData.schedule_publish_at.split(' ')[0]
    },
    schedulePublishAtTime() {
      return this.newsData.schedule_publish_at.split(' ')[1]
    },
    formattedSchedulePublishAt() {
      if (this.newsData.schedule_publish_at === null) {
        return ''
      }

      const fullDate = formatDate(this.newsData.schedule_publish_at).full
      return fullDate.substr(0, fullDate.length - 3)
    },
    uploadApiUrl() {
      return process.env.VUE_APP_API_BASE_URL + 'api/file/upload'
    },
    bearer() {
      return this.$store.state.auth.bearer
    },
  },
  methods: {
    successUploadImage(response) {
      this.$vs.notify({
        color: 'success',
        title: 'Arquivo carregado com sucesso!',
        text: response.data.message
      })

      this.newsData.thumbnail = response.data.fileUrl
    },
    errorUploadImage(response) {
      this.$vs.notify({
        color: 'danger',
        title: 'Ocorreu um erro ao subir o arquivo!',
        text: response.data.message
      })
    },
    deleteUploadImage() {
      this.removePreviousImage()
      this.newsData.thumbnail = null
    },
    handleSubUploadButton() {
      document.getElementById('uploadVideo').click()
    },
    handleVideoClick(ref = "") {
      this.quillEditorRange = this.$refs[`quillEdit${ref}`].quill.getSelection().index
      this.currentRef = ref
      this.videoPopup = true
    },
    handleVideoUpload(e, ref) {
      uploadFile(e).then(uploadedVideo => {
        this.videoPopup = false

        this.$refs[ref].quill.insertEmbed(
          this.quillEditorRange,
          "uploaded-video",
          uploadedVideo.fileUrl
        )
      });
    },
    handleVideoUrl(ref = "") {
      this.videoPopup = false
      this.$refs[ref].quill.insertEmbed(
        this.quillEditorRange,
        "video",
        this.extractVideoUrl(this.videoUrl)
      )
    },
    extractVideoUrl(url) {
      let match =
        url.match(
          /^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/,
        ) ||
        url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/);
      if (match) {
        return `${match[1] || 'https'}://www.youtube.com/embed/${
          match[2]
        }?showinfo=0`;
      }
      // eslint-disable-next-line no-cond-assign
      if ((match = url.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/))) {
        return `${match[1] || 'https'}://player.vimeo.com/video/${match[2]}/`;
      }
      return url;
    },
    /**
     * Detect if image was removed to delete it from Amazon S3
     */
    onTextChange(delta, oldDelta) {
      detectAndRemoveFileFromBucket(oldDelta, this.$refs.quillEdit);
    },
    onTextChange2(delta, oldDelta) {
      detectAndRemoveFileFromBucket(oldDelta, this.$refs.quillEdit2);
    },
    handleImages(e, ref) {
      uploadFile(e).then(uploadedImage => {
        const range = this.$refs[ref].quill.getSelection();
        this.$refs[ref].quill.insertEmbed(
          range.index,
          "image",
          uploadedImage.fileUrl
        );
      });
    },
    handleAudios(e, ref) {
      uploadFile(e).then(uploadedAudio => {
        const range = this.$refs[ref].quill.getSelection();
        this.$refs[ref].quill.insertEmbed(
          range.index,
          "audio",
          uploadedAudio.fileUrl,
          "silent"
        );

        this.$refs[ref].quill.insertText(
          range.index,
          "",
          "user"
        );
      });
    },
    uploadThumbnail(e) {
      this.removePreviousImage();

      uploadFile(e)
        .then(uploadedImage => {
          this.newsData.thumbnail = uploadedImage.fileUrl;
        })
        .catch(err => {
          console.error(err);
        });
    },
    removePreviousImage() {
      const fileUrl = this.newsData.thumbnail;

      if (fileUrl) {
        const urlArray = fileUrl.split("/");
        const filename = urlArray[urlArray.length - 1];

        fileHttp.delete(filename).catch(err => {
          console.error(err);
        });
      }
    },
    setNewsData(data) {
      this.newsData = this.$_.cloneDeep(data);
      this.newsData.content = decodeFromBase64(this.newsData.content);
      this.newsData.hidden_content = decodeFromBase64(
        this.newsData.hidden_content
      );
    },
    submitData() {
      if (!this.newsData.thumbnail) {
        return this.$vs.notify({
          color: 'danger',
          title: 'Ocorreu um ao criar a notícia!',
          text: 'A imagem de miniatura da notícia é obrigatória!'
        })
      }

      if (this.sendingType === '') {
        return this.$vs.notify({
          color: 'danger',
          title: 'Ocorreu um ao criar a notícia!',
          text: 'Você precisa selecionar entre "Publicação Imediata" ou "Selecionar Horário"'
        })
      }

      if (this.sendingType === 'schedule' && this.schedulePublishAtPtBr === '') {
        return this.$vs.notify({
          color: 'danger',
          title: 'Ocorreu um ao criar a notícia!',
          text: 'Você precisa definir uma data e um horário para a publicação automática'
        })
      }

      if (this.sendingType === 'schedule') {
        const ptDate = this.schedulePublishAtPtBr.split(' ')[0].split('/')
        const ptTime = this.schedulePublishAtPtBr.split(' ')[1] + ':00'
        this.newsData.schedule_publish_at = `${ptDate[2]}-${ptDate[1]}-${ptDate[0]} ${ptTime}`
      } else {
        this.newsData.schedule_publish_at = null
      }

      const newsData = this.$_.cloneDeep(this.newsData);
      newsData.content = encodeToBase64(newsData.content);
      newsData.hidden_content = newsData.hidden_content
        ? encodeToBase64(newsData.hidden_content)
        : null;

      this.$validator.validateAll().then(result => {
        if (result) {
          delete newsData.is_main
          delete newsData.is_highlighted

          // newsData.activated = this.disableActivated ? newsData.activated : false

          if (newsData.id !== null && newsData.id >= 0) {
            // Edit
            this.$store
              .dispatch("news/update", newsData)
              .then(() => {
                // Redirect to list page
                this.$router.push("/news/list");
              })
              .catch(err => {
                console.error(err);
              });
          } else {
            // New
            delete newsData.id;
            this.$store
              .dispatch("news/add", newsData)
              .then(() => {
                // Redirect to list page
                this.$router.push("/news/list");
              })
              .catch(err => {
                console.error(err);
              });
          }
        }
      });
    },
    editorOptions(ref = "") {
      return {
        theme: "snow",
        placeholder: "Conteúdo da notícia...",
        modules: {
          toolbar: {
            container: toolbarOptions,
            handlers: {
              image: function() {
                document.getElementById(`selectFile${ref}`).click();
              },
              audio: function () {
                document.getElementById(`selectAudio${ref}`).click();
              },
              video: function () {
                document.getElementById(`selectVideo${ref}`).click();
              }
            }
          }
        }
      };
    }
  },
  async created() {
    this.setNewsData(this.news);

    if (!moduleCategory.isRegistered) {
      this.$store.registerModule("category", moduleCategory);
      moduleCategory.isRegistered = true;
    }

    if (!moduleNews.isRegistered) {
      this.$store.registerModule("news", moduleNews);
      moduleNews.isRegistered = true;
    }

    this.$store.dispatch("category/fetch", {
      activated: true,
      order_by: "name_asc"
    });

    const newsId = this.$route.params.id;

    // The following logic will only work on "update" page
    if (newsId) {
      await this.$store.dispatch("news/infos", newsId);
      this.setNewsData(this.$store.state.news.newsInfos);

      if (this.newsData.schedule_publish_at === null) {
        this.sendingType = 'now'
      } else {
        this.sendingType = 'schedule'
        this.schedulePublishAtPtBr = this.formattedSchedulePublishAt
      }
    }
  },
  mounted() {
    this.$refs.quillEdit.quill.on("text-change", this.onTextChange);
    this.$refs.quillEdit2.quill.on("text-change", this.onTextChange2);
    this.$refs.selectCategory.$el.querySelector('input').setAttribute('autocomplete', 'off')
  },
  components: {
    quillEditor,
    flatPickr,
    VuePerfectScrollbar,
    NewsPreviewPopup,
    Upload
  }
};
</script>